import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class CustomerServiceNote extends AbstractModel {
  @autoserialize
  objectId: number;

  @autoserialize
  text: string;

  @autoserialize
  active: boolean;

  @autoserialize
  objectName: string;

  @autoserialize
  createdBy: string;

  @autoserialize
  createdAt: Date;
}
